import { Button } from '@/components/ui/button';
import { ColumnProps } from '@/components/ui/data-table';
import { QuestionProps } from '@/types/questionnaire';
import { router } from '@inertiajs/react';
import { CircleCheck, X } from 'lucide-react';

export function QuestionColumns({
  sectionId,
  onEdit,
  onDelete,
}: {
  sectionId: number;
  onEdit: (question: QuestionProps) => void;
  onDelete?: (question: QuestionProps) => void;
}): ColumnProps<QuestionProps>[] {
  return [
    { field: 'order', header: 'Order' },
    {
      field: 'key',
      header: 'Identifier',
      render: (question) => (
        <div className="break-words whitespace-normal">
          <code>{question.key}</code>
        </div>
      ),
    },
    {
      field: 'label',
      header: 'Label',
      render: (question) => (
        <div className="break-words whitespace-normal">{question.label}</div>
      ),
    },
    {
      field: 'required',
      header: 'Required',
      render: (question) => (
        <>
          {question.required ? (
            <CircleCheck className="text-green-500" />
          ) : (
            <X className="text-red-500" />
          )}
        </>
      ),
    },
    {
      field: 'options_count',
      header: '# of Options',
      render: (question) => (
        <>{question.options_count ? question.options_count : '-'}</>
      ),
    },
    {
      header: 'Actions',
      render: (question) => (
        <div className="flex gap-2">
          <Button
            size={'sm'}
            variant={'link'}
            className="cursor-pointer"
            onClick={() =>
              router.get(
                `/admin/questionnaire_sections/${sectionId}/questions?question_id=${question.id}`
              )
            }
          >
            View
          </Button>
          <Button
            size="sm"
            variant="link"
            onClick={() => onEdit?.(question)}
            disabled={!onEdit}
          >
            Edit
          </Button>
          <Button
            size="sm"
            variant="link"
            onClick={() => onDelete?.(question)}
            disabled={!onDelete}
            className="text-destructive hover:text-destructive"
          >
            Delete
          </Button>
        </div>
      ),
    },
  ];
}
